(() => {
  const callback = () => {
    const selectors = {
      container: '.cart-discount-offer',
      savingsValue: '[data-cart-discount-offer-savings]',
    };

    const { target_discount_code: targetDiscountCode, discount_percentage: discountPercentage } =
      window.themeComponents.snippets['cart-discount-offer-ds'] ?? {};

    const getCookieByName = (name) => {
      return document.cookie.match('(^|;)\\s*' + name + '\\s*=\\s*([^;]+)')?.pop() || '';
    };

    const toggleOfferVisibility = () => {
      const container = document.querySelector(selectors.container);
      if (!container) return;

      if (targetDiscountCode) {
        const appliedDiscountCode = getCookieByName('discount_code');
        const hasFreeShippingDiscount = appliedDiscountCode === targetDiscountCode;
        container.classList.toggle('hidden', !hasFreeShippingDiscount);
      } else {
        container.classList.remove('hidden');
      }
    };

    toggleOfferVisibility();

    const updateSavings = async (event) => {
      const { cart } = event.detail ?? {};
      if (!cart) return;

      const savingsElement = document.querySelector(selectors.savingsValue);

      const { total_price: totalPrice } = cart;

      if (!totalPrice || !discountPercentage) return;

      const savingsAmount = (totalPrice * discountPercentage) / 100;

      if (savingsElement) {
        savingsElement.innerHTML = theme.Currency.formatMoney(savingsAmount, theme.settings.moneyFormat);
      }
    };

    document.addEventListener('cart:markup-built', updateSavings);
  };

  window.addEventListener('DOMContentLoaded', callback);
})();
